import { render } from "./PhonePart5.vue?vue&type=template&id=3a015216"
import script from "./PhonePart5.vue?vue&type=script&lang=js"
export * from "./PhonePart5.vue?vue&type=script&lang=js"

import "./PhonePart5.vue?vue&type=style&index=0&id=3a015216&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__